var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"5%"}},[_c('Delivery',{attrs:{"suggested_from_address":_vm.proposal.branch_address,"suggested_to_address":_vm.proposal.account_address}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }